// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__2I0uB","fixtures":"styles_fixtures__sAwGx","lightGroup":"styles_lightGroup__3416S","disabled":"styles_disabled__158vJ","text":"styles_text__2Bik_"};